var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8993 10.5996L12.9043 21.3996L11.1043 21.4004L11.0993 10.6004L12.8993 10.5996Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89656 7.04664C3.47985 4.00928 6.77193 2.26259 10.1747 2.65451C13.3418 3.0193 15.9944 5.16649 17.033 8.13725L17.5256 8.13725C17.5254 8.13725 17.5259 8.13725 17.5256 8.13725C19.823 8.13573 22.1041 9.34867 22.858 11.7282C23.5833 14.0175 22.741 16.5129 20.7766 17.8943L20.0404 18.4119L19.005 16.9395L19.7412 16.4218C21.0633 15.4921 21.6302 13.8127 21.1421 12.2718C20.6825 10.8214 19.2472 9.93593 17.527 9.93725L15.6676 9.93725L15.4941 9.26094C14.8281 6.66547 12.6307 4.74929 9.96876 4.44269C7.30674 4.13609 4.73134 5.50253 3.49272 7.87867C2.25411 10.2548 2.60878 13.1486 4.38456 15.1553L4.98099 15.8293L3.633 17.0222L3.03657 16.3482C0.766646 13.7831 0.313277 10.084 1.89656 7.04664Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 9.36322L16.4547 13.8179L15.1819 15.0907L11.9999 11.9088L8.81789 15.0907L7.5451 13.8179L11.9999 9.36322Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.a410ebc4377f7be3f7174b6122531883.svg";
export { ForwardRef as ReactComponent };